import React from "react";

export default function PageContainer({ children }) {
  return (
    <div className="mx-auto w-full max-w-7xl px-6 py-8 lg:px-8">
      {children}
    </div>
  );
}